import { render, staticRenderFns } from "./static-list.component.vue?vue&type=template&id=8958b1b6&scoped=true"
import script from "./static-list.component.vue?vue&type=script&lang=js"
export * from "./static-list.component.vue?vue&type=script&lang=js"
import style0 from "./static-list.component.vue?vue&type=style&index=0&id=8958b1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958b1b6",
  null
  
)

export default component.exports